__webpack_require__.p = "/EDUbox/games/";